/**
 * Helper component for rendering basic text inputs
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import components
import Base from "../BaseComponent.js.jsx";

class TextInput extends Base {
  constructor(props) {
    super(props);
    this._bind('_handleInputChange');
  }

  _handleInputChange(e) {
    this.props.change(e);
  }

  render() {
    const {
      disabled
      , helpText
      , label
      , maxLength
      , name
      , placeholder
      , required
      , value
    } = this.props;
    return (
      <div className="input-group">
        <label htmlFor={name}> {label} {required ? <sup className="-required">*</sup> : null}</label>
        <input
          disabled={disabled}
          maxLength={maxLength}
          name={name}
          onChange={this._handleInputChange}
          placeholder={placeholder}
          required={required}
          type="text"
          value={value}
        />
        <small className="help-text"><em>{helpText}</em></small>
      </div>
    )
  }
}

TextInput.propTypes = {
  change: PropTypes.func.isRequired
  , disabled: PropTypes.bool
  , helpText: PropTypes.any
  , label: PropTypes.string
  , maxLength: PropTypes.string
  , name: PropTypes.string.isRequired
  , placeholder: PropTypes.string
  , required: PropTypes.bool
  , value: PropTypes.string.isRequired
}

TextInput.defaultProps = {
  disabled: false
  , helpText: null
  , label: ''
  , placeholder: ''
  , required: false
  , value: ''
}

export default TextInput;



// WEBPACK FOOTER //
// global/components/forms/TextInput.js.jsx